exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plyr--video .plyr__controls.driver-fix-stacking{z-index:100003!important}#driver-popover-item.popover-class.show-button.popover-last .driver-popover-title{text-align:right;padding-right:10px}", ""]);

// exports
